import React, { useEffect, useState } from "react";
import { formatCurrencyVND } from "../utils/CurrencyFormat";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

const CartPage = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const clientId = localStorage.getItem("client_id") || 0;
  const cart = JSON.parse(localStorage.getItem("cart")) || [];
  const [coupon, setCoupon] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [acceptCoupon, setAcceptCoupon] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    localStorage.removeItem("coupons");
  }, []);

  useEffect(() => {
    setData(cart);
    setAcceptCoupon(null);
  }, [clientId]);

  useEffect(() => {
    const coupons = JSON.parse(localStorage.getItem("coupons"));
    setAcceptCoupon(coupons);
  }, [refresh]);

  const handleDelete = (id) => {
    // if (clientId != 0) {
    //   axios
    //     .delete(`/api/v1/order-details/` + id)
    //     .then((res) => {
    //       toast("Xoá sản phẩm khỏi giỏ hàng thành công!", {
    //         type: "success",
    //         autoClose: 1000,
    //       });
    //     })
    //     .catch((err) => console.log(err));
    // } else {
    let cart = JSON.parse(localStorage.getItem("cart")) || [];

    cart = cart.filter((item) => item.product.id !== id);

    localStorage.setItem("cart", JSON.stringify(cart));

    setData(cart);
    // }
  };

  const calculateTotal = () => {
    let cart = JSON.parse(localStorage.getItem("cart")) || [];

    const total = cart.reduce((sum, product) => {
      return sum + product.product.price * product.quantity;
    }, 0);

    if (acceptCoupon) {
      return total - Number(acceptCoupon.price);
    }

    return total;
  };

  const totalPriceRecord = () => {
    let cart = JSON.parse(localStorage.getItem("cart")) || [];

    const total = cart.reduce((sum, product) => {
      return sum + product.product.price * product.quantity;
    }, 0);

    return total;
  };

  const handleDiscount = () => {
    axios
      .get("/api/v1/coupons/get-by-code/" + coupon)
      .then((res) => {
        const today = new Date().toISOString().split("T")[0];
        if (res.data.endDate < today) {
          toast("Mã giảm giá đã hết hạn!", {
            type: "error",
            autoClose: 1000,
          });
          setCoupon("");
          return;
        }
        setCoupon("");
        localStorage.setItem("coupons", JSON.stringify(res.data));
        setRefresh(!refresh);
        toast("Áp dụng mã giảm giá thành công!", {
          type: "success",
          autoClose: 1000,
        });
      })
      .catch((err) => {
        setCoupon("");
        toast("Mã ưu đãi không hợp lệ!", {
          type: "error",
          autoClose: 1000,
        });
      });
  };

  return (
    <div className="cart-container mt-4">
      <div className="cart-title">
        <i className="bi bi-cart-fill me-2"></i>Giỏ Hàng
      </div>
      {data.length > 0 ? (
        <div className="cart-layout mt-5">
          <div className="cart-left">
            <table>
              <thead>
                <tr>
                  <th>SẢN PHẨM</th>
                  <th>GIÁ</th>
                  <th>SỐ LƯỢNG</th>
                  <th>TẠM TÍNH</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, idx) => (
                  <tr key={idx}>
                    <td>
                      <i
                        className="bi bi-x-circle"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDelete(item.product.id)}
                      ></i>
                      <Link to={item.product.slug}>
                        <img src={item.product.image} alt="" />
                        <div>
                          <p>{item.product.name}</p>
                          <p>
                            {item.quantity} x{" "}
                            {formatCurrencyVND(item.product.price)}
                          </p>
                        </div>
                      </Link>
                    </td>
                    <td>{formatCurrencyVND(item.product.price)}</td>
                    <td>{item.quantity}</td>
                    <td>
                      {formatCurrencyVND(item.product.price * item.quantity)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="cart-right">
            <div className="title-bill">CỘNG GIỎ HÀNG</div>
            <div className="bill-layout mt-4">
              <p>Tạm tính</p>
              <span>{formatCurrencyVND(totalPriceRecord(data))}</span>
            </div>
            {acceptCoupon != null && (
              <div className="bill-layout mt-4">
                <p>{acceptCoupon.code}</p>
                <span>{formatCurrencyVND(acceptCoupon.price)}</span>
              </div>
            )}
            <div className="bill-layout-ship">
              <p>Giao hàng</p>
              <span>Giao hàng miễn phí</span>
            </div>
            <div className="bill-layout mt-3">
              <p>Tổng</p>
              <span>{formatCurrencyVND(calculateTotal(data))}</span>
            </div>
            <div className="button-payment">
              <div
                className="button-quick-buy"
                onClick={() => navigate(`/order`)}
              >
                Tiến hành thanh toán
              </div>
            </div>
            <div
              className="title-bill mt-4"
              style={{ color: "#e5047c", fontSize: 16 }}
            >
              <i className="bi bi-tag-fill me-2"></i>Mã ưu đãi
            </div>
            <input
              type="text"
              name="discount"
              placeholder="Mã ưu đãi"
              id="search"
              className="input-apply mt-3"
              value={coupon}
              onChange={(e) => setCoupon(e.target.value)}
            />
            <div className="button-apply mt-3" onClick={handleDiscount}>
              Áp dụng
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex flex-column mt-5">
          Chưa có sản phẩm trong giỏ hàng
          <button
            className="login-signup-button mt-3"
            onClick={() => navigate(`/`)}
          >
            Quay về trang chủ
          </button>
        </div>
      )}
    </div>
  );
};

export default CartPage;
